import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
const interfaceFun = {
  state: {},
  actions: {
    // 24小时用能分析
    async publicGetFourEC({}, { params }) {
      let obj = {
        unit: "",
        xData: [],
        yArr: [],
      };
      let res = await api.OSAnalysisFourEC(params);
      if (res && res.data.code == 200) {
        obj.unit = res.data.data[0]?.unit;
        res.data.data.map((v) => {
          obj.xData.push(v.name + "时");
          obj.yArr.push(v.value);
        });
      }
      return obj;
    },
    // 用能分析中用电排行
    async publicGetECData({}, { params }) {
      let obj = {
        unit: "",
        xData: [],
        dataArr: [{ name: "用电量", data: [] }],
      };
      let res = await api.OSAnalysisECData(params);
      if (res && res.data.code == 200) {
        obj.unit = res.data.data[0]?.unit;
        res.data.data.map((v) => {
          obj.xData.push(
            params.type == "MONTH"
              ? dateFtt("dd日", new Date(v.ts))
              : params.type == "YEAR"
              ? dateFtt("MM月", new Date(v.ts))
              : dateFtt("yyyy年", new Date(v.ts))
          );
          obj.dataArr[0].data.push(v.value);
        });
      }
      return obj;
    },
  },
};
export default interfaceFun;
